var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6cdb218870fc395a81486fb3a04692bed3d4cf0a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["versi@kalkul-inc"]={id:"6cdb218870fc395a81486fb3a04692bed3d4cf0a"};
      